import React from 'react'
import { useSelector } from 'react-redux'
import { USER_SCREENS } from '../../../store/ui/ui.constants'
import { selectUserUIScreen } from '../../../store/ui/ui.selectors'
import { withUserConnected } from '../shared/withKeycloak'
import UserFavorites from './userFavorites/UserFavorites'
import UserManageFavorite from './userFavorites/UserManageFavorite'
import UserItineraryOptions from './userItineraryOptions/UserItineraryOptions'
import UserMenu from './userMenu/UserMenu'

const UserAreaConnected = () => {
  const screen = useSelector(selectUserUIScreen)

  switch (screen) {
    case USER_SCREENS.favorites:
      return <UserFavorites />
    case USER_SCREENS.manageFavorite:
      return <UserManageFavorite />
    case USER_SCREENS.itineraryOptions:
      return <UserItineraryOptions />
    case USER_SCREENS.default:
    default:
      return <UserMenu />
  }
}

export default withUserConnected(UserAreaConnected)
